// extracted by mini-css-extract-plugin
var _1 = "webpack-components-PrivacyAndPermissions-EmailPermissions-module__textWrapper";
var _2 = "webpack-components-PrivacyAndPermissions-EmailPermissions-module__wrapper";
export { _1 as "textWrapper", _2 as "wrapper" }
